import { render, staticRenderFns } from "./AttributeField.vue?vue&type=template&id=3c4ed8a9"
import script from "./AttributeField.vue?vue&type=script&lang=js"
export * from "./AttributeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports